export default [
  {
    path: '/board/:boardType',
    component: () => import('@/views/board/boardList.vue')
  },
  {
    path: '/board/:boardType/:boardNo/:locale',
    component: () => import('@/views/board/boardDetail.vue')
  }
];
